import { logError } from '@databases/logs';

/**
 * Copies a value to the clipboard
 */
export const copyToClipboard = async (
  value: string,
  type: 'text/plain' | 'text/html'
): Promise<boolean> => {
  try {
    await navigator.clipboard.write([
      new ClipboardItem({
        [type]: new Blob([value], { type }),
      }),
    ]);
    return true;
  } catch (possibleError) {
    const error =
      possibleError instanceof Error ? possibleError : new Error(String(possibleError));
    logError('Error while copying to clipboard', error);
    return false;
  }
};
